import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import React from 'react';
import { messengerLanguages, } from '../../languages';
import { LanguageSelectorItem } from './components';
import { FirstRow } from './components/languageListHeader/LanguageListHeader';
import style from './style.module.scss';
export function LanguageSelector({ selectedLanguage, onSelectLanguage, defaultLanguageCode, fields, }) {
    var _a;
    const activeLanguages = (_a = fields.getAll()) !== null && _a !== void 0 ? _a : [];
    function onToggleLanguage(langCode, isChecked) {
        const index = activeLanguages.findIndex((l) => l === langCode);
        if (isChecked) {
            if (index === -1) {
                fields.push(langCode);
            }
        }
        else {
            if (index !== -1) {
                fields.remove(index);
            }
        }
    }
    return (_jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "200" }, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", className: style.languagesContainer }, { children: [_jsx(FirstRow, {}), messengerLanguages.map(({ code, label }) => {
                    const isEnabled = activeLanguages.includes(code);
                    const thereIsOnlyOneEnabledLang = activeLanguages.length === 1;
                    const isSelected = selectedLanguage === code;
                    const handleSelected = (_) => onSelectLanguage(code);
                    const onSwitchChange = (e) => onToggleLanguage(code, e.currentTarget.checked);
                    return (_jsx(LanguageSelectorItem, { defaultLanguageCode: defaultLanguageCode, langCode: code, langName: label, isEnabled: isEnabled, thereIsOnlyOneEnabledLang: thereIsOnlyOneEnabledLang, isCurrentlySelected: isSelected, onSwitchChange: onSwitchChange, onClick: handleSelected }, code));
                })] })) })));
}
